import { helpers } from 'vuelidate/lib/validators';
export default helpers.regex('postalCode', /^[A-Za-z0-9 \-]{0,60}$/);
